<ng-template #cloneDialog let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="clone-modal-title">
			<mat-icon style="vertical-align:middle;margin-right:6px">content_copy</mat-icon>
			Clone "{{ cloneSourceUser?.realname || cloneSourceUser?.userid }}"
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body" *ngIf="cloneForm" [formGroup]="cloneForm">
		<p class="text-muted small mb-3">All permissions, locations, and settings will be copied. You only need to set a new username and password.</p>
		<mat-form-field appearance="outline" class="w-100 mb-2">
			<mat-label>New User ID</mat-label>
			<input matInput formControlName="userid" placeholder="e.g. jsmith2" autocomplete="off">
			<mat-error *ngIf="cloneForm.get('userid').hasError('required')">Required</mat-error>
			<mat-error *ngIf="cloneForm.get('userid').hasError('pattern')">Letters, numbers, - and _ only</mat-error>
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Password</mat-label>
			<input matInput [type]="cloneHidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password">
			<button mat-icon-button matSuffix type="button" (click)="cloneHidePassword = !cloneHidePassword" [matTooltip]="cloneHidePassword ? 'Show' : 'Hide'">
				<mat-icon>{{ cloneHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
			</button>
			<button mat-icon-button matSuffix type="button" (click)="generateClonePassword()" matTooltip="Generate password">
				<mat-icon>vpn_key</mat-icon>
			</button>
			<mat-error *ngIf="cloneForm.get('password').hasError('required')">Required</mat-error>
		</mat-form-field>
	</div>
	<div class="modal-footer">
		<button mat-button (click)="modal.dismiss()">Cancel</button>
		<button mat-raised-button color="primary" [disabled]="!cloneForm?.valid || cloning" (click)="submitClone()">
			<mat-spinner *ngIf="cloning" diameter="18" strokeWidth="3" style="display:inline-block;margin-right:6px"></mat-spinner>
			Clone User
		</button>
	</div>
</ng-template>

<ng-template #userdetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">User Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<app-user-edit [user]="selecteduser" [suppressPageChrome]="true" (updated)="updateUser($event)"></app-user-edit>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Users</h4>
						<p class="card-category text-right">User Information</p>
					</div>
					<div class="card-body">
						<!-- Controls -->
						<div class="row align-items-center mb-3">
							<div class="col-md-4 text-left d-flex align-items-center">
								<a mat-raised-button color="accent" [routerLink]="'/users/create'">New User</a>
								<a *ngIf="showVendorLogins" mat-stroked-button color="accent" class="ml-2" [routerLink]="'/users/vendors'" title="Create and manage brand/vendor portal logins">
									<i class="material-icons align-middle" style="font-size:18px">vpn_key</i> Vendor Logins
								</a>
<button class="btn btn-success btn-sm export-btn ml-2" (click)="exportXls()" [disabled]="exporting || !(users?.data?.length)">
									<i class="fa fa-file-excel-o"></i>
								</button>
								<button class="btn btn-danger btn-sm export-btn ml-2" (click)="exportPdf()" [disabled]="exporting || !(users?.data?.length)">
									<i class="fa fa-file-pdf-o"></i>
								</button>
							</div>

							<div class="col-md-2 text-left">
								<mat-slide-toggle [formControl]="filterdisabled" (click)="searchUsers()">
									Include Disabled
								</mat-slide-toggle>
							</div>

							<div class="col-md-3">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Filter by Group</mat-label>
									<mat-select [formControl]="groupFilter" (selectionChange)="searchUsers()">
										<mat-option value="">All Groups</mat-option>
										<mat-option *ngFor="let group of groupOptions" [value]="group">{{ group }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="col-md-3">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Search</mat-label>
									<input matInput (input)="onInput()" [formControl]="userSearch" (keydown.enter)="$event.preventDefault(); onInput()" autofocus>
									<button mat-icon-button matSuffix (click)="searchUsers()">
										<mat-icon>search</mat-icon>
									</button>
									<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isSearching"></mat-progress-bar>
								</mat-form-field>
							</div>
						</div>

						<!-- Table -->
						<div class="user-table-wrapper mt-4">
							<table class="table table-hover table-striped user-table table-bordered">
								<thead class="thead-dark text-uppercase text-white">
									<tr>
										<th scope="col">Actions</th>
										<th scope="col">User ID</th>
										<th *ngIf="config.env.package === 'beauty'" scope="col">Emp #</th>
										<th scope="col">Name</th>
										<th scope="col">Role</th>
										<th scope="col">Disabled</th>
										<th scope="col">View Cost</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let user of users.data">
										<td>
											<button class="btn btn-sm btn-outline-primary mr-1" (click)="openUser(user)" title="Edit User">
												<i class="fa fa-edit"></i>
											</button>
											<button class="btn btn-sm btn-outline-secondary mr-1" (click)="openCloneDialog(user)" title="Clone user">
												<i class="fa fa-copy"></i>
											</button>
											<button *ngIf="user.blocked !== '1'" class="btn btn-sm btn-outline-warning" (click)="disableUser(user)" [disabled]="isCurrentUser(user)" title="Disable user (they will not be able to log in)">
												<i class="fa fa-ban"></i>
											</button>
											<button *ngIf="user.blocked === '1'" class="btn btn-sm btn-outline-success" (click)="enableUser(user)" title="Re-enable user">
												<i class="fa fa-check-circle"></i>
											</button>
										</td>
										<td>
											<span [innerHTML]="user.userid | highlight: userSearch.value"></span>
										</td>
										<td *ngIf="config.env.package === 'beauty'">
											<span [innerHTML]="user.empcode | highlight: userSearch.value"></span>
										</td>
										<td>
											<span [innerHTML]="user.realname | highlight: userSearch.value"></span>
										</td>
										<td>
											<span [innerHTML]="user.groupname | highlight: userSearch.value"></span>
										</td>
										<td>{{ user.blocked === '1' ? 'Yes' : 'No' }}</td>
										<td>{{ user.viewcost === '1' ? 'Yes' : 'No' }}</td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>

				</div>
			</div>
		</div>
	</div>
</div>